/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Quote, RestResponse } from '../model';
import { SearchableProvider } from "../model/interface/searchable.provider";
import { ApiHeaders } from './headers';
import { SystemType } from "../model/enums/system.type";

@Injectable()
export class QuoteLinkProvider implements SearchableProvider {
  constructor(
    private http: HttpClient
  ) { }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number, position?: string, type?: SystemType): Observable<RestResponse> {
    // in id we are passing selected tags
    return this.getQuotes(page ? page : 1, 25, true, 'CREATED_DATE', type, null, query);
  }

  getQuotes(page: number, size: number, sort: boolean, order: string, type: string, qType?: string, query?: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/quote/report/list/links?page=${page}&size=${size}&sort=${sort}&order=${order}`,
        {
          TYPE: type,
          QUERY_TYPE: qType,
          QUERY: query,
        },
        ApiHeaders.getOptions());
  }


  save(id: string, field: string, value: any): Observable<RestResponse> {
    return null;
  }

  getSearchType(): string {
    return 'REPORT';
  }
}
